export default `
<!-- OneTrust Cookies Consent Notice start for docs.rapyd.net -->
<script 
    src="${CONSENT_COOKIE_SCRIPT_SRC}" 
    data-document-language="true" 
    type="text/javascript" 
    charset="UTF-8" 
    data-domain-script="${CONSENT_COOKIE_SCRIPT_DOMAIN_ID}" >
</script>
<script type="text/javascript">
function OptanonWrapper() { }
</script>
<!-- OneTrust Cookies Consent Notice end for docs.rapyd.net -->
`;
